import ActionTypes from "../constants/action_types";

export default function clearContractTypes() {
  return {
    type: ActionTypes.CONTRACT_TYPES_CLEAR.SUCCESS,
  };
}
